export const LOAD_PROCESS_DEFINITIONS = 'LOAD_PROCESS_DEFINITIONS';
export const LOAD_PROCESS_DEFINITIONS_LOADING = 'LOAD_PROCESS_DEFINITIONS_LOADING';
export const LOAD_PROCESS_DEFINITIONS_SUCCESS = 'LOAD_PROCESS_DEFINITIONS_SUCCESS';
export const LOAD_PROCESS_DEFINITIONS_FAILURE = 'LOAD_PROCESS_DEFINITIONS_FAILURE';
